module.exports = __webpack_public_path__ + "static/media/fb_my.54352382.png";